export enum Topic {
  COVID19 = "COVID-19",
  Blockchain = "Blockchain",
  // FiveG = "5G",
}
